/*eslint-disable */
define(function (require) {
    'use strict';

    var Backbone = require('backbone'),
        $ = require('jquery'),
        _ = require('underscore'),
        Mustache = require('mustache'),
        moment = require('moment'),
        TimeSelectionCollection = require('site/page/checkout/time-selection-collection'),
        TimeSlotSelector = require('common/util/select-default-time-slot'),
        ga = require('common/analytics/google-analytics'),
        config = require('common/page-config'),
        events = require('common/event-aggregator'),
        iScroll = require('thirdparty/iscroll').iScroll;

    const MIN_TIME_SLOT_ROWS = 3;
    const TIME_SLOT_ROW_HEIGHT = 44;

    require('thirdparty/jquery.scrollshadow');


    var TimeSelectionView = Backbone.View.extend({
        config: config,
        slotsTemplateId: 'booking-mobile-datetime-time-slots',
        emptySlotsTemplateId: 'booking-mobile-datetime-unavailable',

        collection: new TimeSelectionCollection(),

        events: {
            'click .slot': 'onSlotClicked'
        },

        selectedDate: null,
        selectedTime: null,
        lastSelectedTime: null,
        timeFrom: null,
        timeTo: null,
        selectedEmployee: null,

        initialize: function (options) {
            this.options = options;
            // listen to day selection event
            this.listenTo(events, events.CHECKOUT_AVAILABILITY_DAY_SELECTED, this.onDayChanged);
            this.listenTo(events, events.CHECKOUT_AVAILABILITY_TIME_SELECTED, this.resetHeight);
            this.listenToOnce(events, events.CHECKOUT_AVAILABILITY_PAGE_LOADED, this.resetHeight);
            window.addEventListener("resize", this.resetHeight.bind(this));

            // if there is a selectedTime int the options add it
            if (this.options.selectedTime) {
                this.selectedTime = this.options.selectedTime;
            }
        },

        getSiblingsHeight () {
          const siblings = this.$el.parent().siblings();
          let siblingsHeight = 0;

          siblings.each((index, node) => {
            if ($(node).hasClass("loading-availability-message")) {
              return siblingsHeight;
            }

            siblingsHeight = siblingsHeight + node.offsetHeight;
          });

          return siblingsHeight;
        },

        getMinHeight () {
          return TIME_SLOT_ROW_HEIGHT * MIN_TIME_SLOT_ROWS;
        },

        resetHeight: function () {
          const parent = this.options.resetHeightParent;
          let continueButtonHeight = 0;
          const directSiblings = this.$el.siblings();
          directSiblings.each((index, node) => {
            if ($(node).hasClass("continue-button")) {
              continueButtonHeight = node.offsetHeight;
            }
          });
          
          let heightToRemove = this.getSiblingsHeight() + parent.find('.js-navigation').outerHeight() + 2 + continueButtonHeight;
          if (parent.find('.head').length > 0) {
            heightToRemove = heightToRemove + parent.find('.head').outerHeight();
          }
          
          let newHeight = Math.max(this.options.resetHeightFrom.height() - heightToRemove, this.getMinHeight());
          
          if (config.isMobile) {
            this.$el.find('.time-slots-wrapper').height(newHeight);
          } else {
            newHeight = newHeight + 16;
            this.$el.height(newHeight);
          }
        },

        render: function () {
            ga.trackPageViewWithUtm('/checkout/availability/time-select/?venueId=' + this.options.venueId);

            // initialize scroll shadow plugin
            if (!config.isMobile) {
                this.$el.scrollshadow(null, {
                    bottomShadow: true,
                    max: 10
                });
            }
        },

        renderSlots: function () {
            var dateFormat = this.config.locale.dateTimeFormats['long-day-cardinal-date-long-month'].javascriptMomentFormat;
            var template = $('#' + (this.collection.length ? this.slotsTemplateId : this.emptySlotsTemplateId)).html();
            var data = (this.collection.length) ? this.collection.toJSON() : {date: moment(this.selectedDate).format(dateFormat) };
            // show loading message
            this.toggleLoading(true);
            // render template
            this.$el.find('.time-slots-wrapper').html(Mustache.render(template, data));
            // select slot
            if (this.options.selectInitialSlot || this.selectedTime || this.lastSelectedTime) {
                this.selectInitialSlot();
            }
            // hide loading
            this.toggleLoading(false);
            // set the height of the time slots wrapper
            this.resetHeight();

            // if no employee availability trigger CHECKOUT_AVAILABILITY_EMPLOYEE_NOT_AVAILABLE
            if (this.collection.length === 0) {
                events.trigger(events.CHECKOUT_AVAILABILITY_EMPLOYEE_NOT_AVAILABLE);
            }
        },

        toggleLoading: function (action) {
            this.$el.find('.loading-message').toggle(action);
        },

        selectInitialSlot: function () {
          var slotNode, timeSlot,
              originalTimeSlot = TimeSlotSelector(this.collection.getAvailableTimes(), {
                  preferredTime: (this.selectedTime || this.lastValidSelectedTime),
                  timeFrom: this.options.timeFrom,
                  timeTo: this.options.timeTo
              }
          );
          if(this.collection.getAvailableTimes().length < 1) {
            $(".continue-button").hide();
          } else {
            $(".continue-button").show();
          }
          
          if(originalTimeSlot < 0) {
            timeSlot = this.selectedTime ? this.selectedTime : this.lastSelectedTime;
          } else {
            timeSlot = originalTimeSlot;
          }
          this.selectedTime = timeSlot;

          slotNode = $('.slot[data-time="' + timeSlot + '"]').first();

          if(this.collection.getAvailableTimes().length > 0) {
            // select the initial selected slot
            this.onSlotSelected({currentTarget: slotNode});
            // scroll into selected slot
            setTimeout(_.bind(function () {
                this.scrollToSelectedSlot();
            }, this), 0);
          }
      },

        onSlotClicked: function (event) {
            var indexOfSelectedTime = Array.from(event.currentTarget.parentNode.children).indexOf(event.currentTarget);
            // 1 indexed rather than 0 indexed
            this.options.track.select(indexOfSelectedTime + 1)
            this.onSlotSelected(event);
        },

        onSlotSelected: function (event) {
            if (event) {
                var slotNode = $(event.currentTarget);
                // update slots classes
                slotNode.addClass('on').siblings().removeClass('on');
                // set the selected time slot
                this.lastSelectedTime = this.selectedTime;
                this.selectedTime = slotNode.data('id');
            }

            // fire event checkout-availability:DaySelected with day collection's model
            events.trigger(events.CHECKOUT_AVAILABILITY_TIME_SELECTED, {
                date: this.selectedDate,
                time: this.selectedTime,
                employeeId: this.selectedEmployee,
                services: this.getSlotServiceDetails(),
                event: event.type ? event.type : ''
            });
        },

        getSlotServiceDetails: function () {
            // prepare services and skus data to be sent when firing event
            var slot = this.collection.get(this.selectedTime);

            if (!slot) {
                return [];
            }

            return _.map(slot.get('services'), _.bind(function (service) {
                return {
                    serviceId: service.serviceId,
                    skus: _.map(service.skus, function (sku) {
                        return {
                            skuId: sku.skuId,
                            price: sku.salePrice.amount
                        };
                    })
                };
            }, this));
        },

        scrollToSelectedSlot: function () {
            var selected = this.$el.find('.slot.on'),
                positionTop = (selected.index() - 3) * selected.outerHeight();

            if (selected.length) {
              // The element to scroll is different for mobile and desktop pages.
              // Scrolling both is harmless, as one will not be scrollable on each platform.
              $("#time-page-time-scroll, #time-slots-wrapper").animate({
                scrollTop: positionTop || 0
              });
            }

            // Trigger scroll event to update the scrollshadow plugin
            this.$el.trigger('scroll');
        },

        onDayChanged: function (data) {
            // set the selected date
            this.selectedDate = data.day.get('date');
            // set the selected employee
            this.selectedEmployee = data.employee ? data.employee.employeeId : null;
            // get selected slot

            // update collection
            this.collection.loadSlots({
                employee: this.selectedEmployee,
                slots: data.day.get('slots')
            });
            // render the time slots
            this.renderSlots();
        },

        destroy: function () {
            this.stopListening(events, events.CHECKOUT_AVAILABILITY_DAY_SELECTED, this.onDayChanged);
            this.undelegateEvents();
        }
    });

    return TimeSelectionView;
});
